export class Logo {
    Id: string;
    lg_content: string;
    lg_overall: string;
    lg_start: string;
}

export class FileLogo {
    content: string;
    fileName: File;
}



// WEBPACK FOOTER //
// ./src/app/models/logo.model.ts